import Helper from './Helper';
import { runInThisContext } from 'vm';

class Searchform {
  constructor() {
    this.toggler = document.querySelectorAll('.js-search-toggle');
    this.togglerArray = Array.prototype.slice.call(this.toggler);
    this.target = document.querySelector('#js-searchform');
    this.targetAnimate = this.target.querySelector('.searchform');
    this.target.style.display = 'none';
    this.backDrop = document.querySelector('#js-search-backdrop');
    this.bindEvents();
  }

  bindEvents() {
    this.togglerArray.forEach(toggler => {
      toggler.addEventListener('click', e => {
        this.toggleSearch(e);
      })
    });
    this.backDrop.addEventListener('click', e => {
      // console.log("Backdrop ckicked");
      this.closeSearch();
    });
  }

  toggleSearch(e){
    let mobile = false;
    let clickedElement = event.target.closest('.js-search-toggle');
    this.input = document.querySelector('.searchform__input');
    if(!clickedElement.disabled){
      clickedElement.disabled = true;
      setTimeout(() => { clickedElement.disabled = false; }, 500);

      if(clickedElement.classList.contains('header__searchlink--mobile')){
        mobile = true;
      }

      if(this.target.style.display == 'none'){
        if(!mobile){
          let rect = clickedElement.getBoundingClientRect();
          this.target.style.right = (document.body.offsetWidth - rect.left - clickedElement.offsetWidth - 4);

          if(document.querySelector('.header').classList.contains('js-header--show')){
            this.target.style.top = (rect.top + 5);
          } else{
            this.target.style.top = (rect.top - 7);
          }

          this.activateBackdrop();
          this.input.addEventListener('keyup', e => {
            if (e.keyCode == 27) {
              this.input.removeEventListener('keyup', e);
              this.closeSearch();
            }
          });
        }
        this.target.style.display = 'block';

        setTimeout(() => { this.targetAnimate.classList.toggle('active'); }, 100);
        this.input.focus();

      } else{
        this.closeSearch();
      }
    }
  }

  closeSearch(e){
    this.removeBackdrop();
    this.targetAnimate.classList.remove('active');
    setTimeout(() => { this.target.style.display = 'none'; }, 400);
  }

  activateBackdrop(){
    this.backDrop.style.display = 'block';
  }

  removeBackdrop(){
    this.backDrop.style.display = 'none';
  }

} export default Searchform;
